import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type FloraTooltipState = {
  seenTooltips: Record<string, boolean>
}

type FloraTooltipActions = {
  markTooltipSeen: (triggerId: string) => void
  hasSeenTooltip: (triggerId: string) => boolean
}

type FloraTooltipStore = FloraTooltipState & FloraTooltipActions

export const useFloraTooltipStore = create<FloraTooltipStore>()(
  persist(
    (set, get) => ({
      seenTooltips: {},

      markTooltipSeen: (triggerId: string) =>
        set(state => ({
          seenTooltips: { ...state.seenTooltips, [triggerId]: true }
        })),

      hasSeenTooltip: (triggerId: string) =>
        Boolean(get().seenTooltips[triggerId])
    }),
    {
      name: 'flora-tooltip-store',
      partialize: state => ({
        seenTooltips: state.seenTooltips
      })
    }
  )
)
